import { TopBarAccountButtonGreeting } from './TopBarAccountButtonGreeting';
import { TopBarAccountButtonIcon } from './TopBarAccountButtonIcon';
import { TopBarAccountButtonRoot } from './TopBarAccountButtonRoot';

export const TopBarAccountButton = Object.assign(TopBarAccountButtonRoot, {
  Greeting: TopBarAccountButtonGreeting,
  Icon: TopBarAccountButtonIcon,
});
